module.exports = __webpack_public_path__ + "static/media/Spinner-1s-200px.a4dc88be.svg";